import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { serialize } from '../../utility/serialize';
import { TaxExemptionReasonType } from '../../shared/models/catalog/taxExemptionReasonType';
import { TaxExceptionReasonTypeFilterSet } from '../../shared/models/catalog/tax-exception-reason-type-filter-set';

export const taxExemptionReasonTypeApi = createApi({
  reducerPath: 'taxExemptionReasonTypeApi',
  baseQuery,
  tagTypes: ['TaxExemptionReasonTypes'],
  endpoints: (builder) => ({
    getTaxExemptionReasonTypes: builder.query<
      IPagedResult<TaxExemptionReasonType>,
      TaxExceptionReasonTypeFilterSet
    >({
      query: (filterSet) => ({
        url: `/api/taxexemptionreasontypes?${serialize(filterSet)}`,
        method: 'GET',
      }),
      providesTags: ['TaxExemptionReasonTypes'],
    }),
  }),
});

export const { useGetTaxExemptionReasonTypesQuery, useLazyGetTaxExemptionReasonTypesQuery } =
  taxExemptionReasonTypeApi;
